import { render, staticRenderFns } from "./MyFollow.vue?vue&type=template&id=487da1b3&scoped=true"
import script from "./MyFollow.vue?vue&type=script&lang=js"
export * from "./MyFollow.vue?vue&type=script&lang=js"
import style0 from "./MyFollow.vue?vue&type=style&index=0&id=487da1b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487da1b3",
  null
  
)

export default component.exports